import React, {useState} from 'react';
import './AdminFolderer.scss';
import { closeAdminFoldererView, uploadAddNoteFiles, changeAdminPdfView, setPdfFileName, 
    openDeleteInputFormsForAddFile,closeDeleteInputFormsForAddFile, addFileDelete, validateAddFileSize, 
    validateNoteImageSize,
    validateAddFileType} from '../../../../adminSlice';
import pdfIconFile from '../../../../../../styles/svg_notes/pdf-file.svg';
import { formatDate } from '../../../../../../helper/formatData';
import DeleteInputFormsForAddFiles from '../../InputForms/DeleteInputFormsForAddFiles';
import { validateTypeAddFile, validateSizeAddFile } from '../../../../../../helper/validation';
import { clearErrorsValidateAddFile } from '../../../../adminSlice';

const AdminFolderer = (props) => {

    const [selectedFiles, setSelectedFiles] = useState([]);
    const [validate, setValidate] = useState(false); 
    
    const {dispatch} = props;
    
    //const foldersData = [];
const iconFile = pdfIconFile;




//ON CLICK CLOSE
        const onClickClose = () => {
            dispatch(closeAdminFoldererView());
            dispatch(clearErrorsValidateAddFile());
           // dispatch(closeViewInputFormsForTroubles());
           // dispatch(closeViewIAnswerForTroubles());
           // console.log('get answer for trouble');
        }
    // CLEAR INPUT FORMS
    const clearInputForms = () => {
        
        setSelectedFiles([]);
    } 
    // SET AFF NOTE FILES
    const selectFiles = (e) => {
        
        setSelectedFiles(e.target.files);
        console.log(e.target.files[0]);

            //validate type image
            const addFile = document.getElementById('note-addfiles');
            console.log(addFile);
            let valideTypeMessage = validateTypeAddFile(addFile);
            
            dispatch(validateAddFileType(valideTypeMessage));
            //validate size image
            let valideSizeMessage = validateSizeAddFile(addFile);
           // console.log(valideTypeMessage);
            console.log(valideSizeMessage);
           // console.log(e.target.files);
            dispatch(validateAddFileSize(valideSizeMessage));
console.log(e.target.files.length);

       if ((valideTypeMessage === true) && (valideSizeMessage === true) && (e.target.files.length !== 0)) {
        setValidate(true);
        
       } else {
        setValidate(false);
       }


    }
    //CLEAR INPUT FILE NAME
const clearInputFile = () => {
   document.getElementById('note-addfiles').value = '';
}

   //HANDLE UPLOAD -ADD PART NOTE
   const handleUploadAddNoteFiles = e => {
   console.log('WTF');
       
       e.preventDefault();

        //const valideTypeMessage = false;
        //const valideSizeMessage = false;
       const valideTypeMessage = props.errorAddFileValidateType;
       const valideSizeMessage = props.errorAddFileValidateSize;

   
   if (!valideTypeMessage && !valideSizeMessage) {
      console.log('START UPLOAD add note files AFTER GOOG VALIDATION');
      // console.log(props.selectedIdNote, notePartTitle,notePart,noteText,noteImgText, selectedFiles );
       let formData = new FormData();
       formData.append("note_id",props.selectedIdNote);
      
       formData.append("file", selectedFiles[0]);
       
       console.log(formData);
      dispatch(uploadAddNoteFiles(formData));

   
      //clear input forms
       clearInputForms();
       clearInputFile();

   
   } else return null;
   
     
     }
    //HANDLE VIEW PDF 
    const handleClickPdfViewer  = (e) => {

        const data = {
            
            pdfName: e.target.value,
        };
        console.log(data);
      
// PDF VIEW DISABLED!!!!! SEE ALSO ADMINNOTE- PDF WORKER!!!

 /*
        dispatch(setPdfFileName(data.pdfName));
        dispatch(changeAdminPdfView());
        */
    }
   //OPEN DELETE ADD FILE INPUT FORM
   const handleDeleteAddFileInputForm = (e) => {
   // console.log('del add file');
    
    dispatch(openDeleteInputFormsForAddFile(e.currentTarget.value));
   }
   //DELETE ADD FILE
      const handledeleteAddFile = () => {
    console.log('del add file');

        const item ={
            noteId: props.selectedIdNote,
            id: Number(props.selectedIdAddFile),
        }
        dispatch(addFileDelete(item));
        dispatch(closeDeleteInputFormsForAddFile());
    //dispatch(openDeleteInputFormsForAddFile(e.target.files));
   }

    //RENDER CONTENT 

   /* const renderContent = (data) => {
        

        return (

            data.map(item => {
                console.log(item);

            })

        )
    
    }
*/
    //RENDER FILES TABLE
      const  renderFilesTable = () => {
       // let  data =  [{titles:'example.pdf',size:1234, data:"12/3/25"},{titles:'first01.pdf',size:124, data:"12/3/25"}];
        const data = props.noteAddFiles;

        return (
            data.map((item, index) => {
                console.log(item);
                return(
                    <div className='tr'  key={index}>
                        
                        <img  src={iconFile} alt="icon" className="iconFile"/><p className='titles'>{item.filename}</p>
                        <p className='size'>{(item.filesize/1048576).toFixed(1)}МБ</p>
                        <p className='data'>{formatDate(item.data)}</p>
                        <p ><button className='btnFavorites' onClick={handleClickPdfViewer} value={item.filename} >View</button></p>
                        <p ><button className='btnFavorites'>download</button></p>
                        <p><button className='smallbtnDelete' value={item.id} onClick={handleDeleteAddFileInputForm}></button></p>
                    </div>
                    )
                })
            )    
       }




    return (
        <div className='AdminFolderer'>
            
                <div className="return-menu">
                       <button className="exit" onClick={onClickClose}></button>
                </div>
                <div className='header'> 
                    <p className='p-text'>Дополнительные файлы:</p>
                    
                    <input id='note-addfiles' type="file" accept="application/pdf" onChange={selectFiles}  />
                    <p className='p-text'>Допустимые форматы -pdf. Допустимый размер файла до 10Мб</p>
                    <p className='err-text'>{props.errorAddFileValidateSize}</p>
                    <p className='err-text'>{props.errorAddFileValidateType}</p>
                    <button className='upload' onClick={handleUploadAddNoteFiles } disabled={ validate ? false : true}> Загрузить</button>
                </div>
                
                
                    <p className='titleFolder'>{props.selectedIdNote}/</p>
                     <div className='table'>
                            <div className='thead'>
                                <div className='tr tr-head'>
                                    
                                    <p className='th titles'>Наименование</p>                            
                                    <p className='th size'>Размер</p>
                                    <p className='th data'>Дата</p>
                                   
                                </div>
                                
                            </div>
                            <div className='tbody'>
                            
                                {renderFilesTable()}
                            
                            </div>
                    
                
                    </div>
                    {props.openDeleteInputFormsForAddFile && <DeleteInputFormsForAddFiles
                    handledeleteAddFile = {handledeleteAddFile}
                    dispatch={dispatch}
                    />}
           
           
        </div>
    )
    
}
export default AdminFolderer;